import * as React from 'react';
import { cn } from '../../utils/cn';

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    unstyled?: boolean;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, unstyled = false, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          unstyled
            ? 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 disabled:cursor-not-allowed'
            : 'flex min-h-[80px] w-full rounded-md border border-border bg-surface px-3 py-2 text-sm ring-offset-background placeholder:text-ink-subtle dark:bg-surface-strong dark:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 dark:focus-visible:ring-[rgb(var(--color-neon))] focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
